import { EndType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * Checks whether a pricing variant billing has no end date, meaning the user will be charged until the plan is canceled.
 * Both recurring and one time plan variants can be unlimited.
 * @returns true if variant is unlimited.
 */

export const isUnlimitedVariant = variant => {
  var _variant$billingTerms;
  return ((_variant$billingTerms = variant.billingTerms) == null ? void 0 : _variant$billingTerms.endType) === EndType.UNTIL_CANCELLED;
};
//# sourceMappingURL=is-unlimited-variant.js.map